import React from "react";

export const Eyebrow = ({
    children,
    withDot = false,
    accent = false,
    className = "",
    ...props
}) => {
    const color = accent ? "text-[var(--accent)]" : "text-text-muted";
    return (
        <span
            className={`inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-widest-2 ${color} ${className}`}
            {...props}
        >
            {withDot && (
                <span
                    aria-hidden
                    className="h-1.5 w-1.5 rounded-full bg-[var(--accent)] animate-pulse-dot"
                    style={{ boxShadow: "0 0 10px rgba(124,255,79,0.6)" }}
                />
            )}
            {children}
        </span>
    );
};

export default Eyebrow;
